(() => {
  function init(root) {
    if (root.dataset.vnBound) return;
    root.dataset.vnBound = 'true';
    let lastTrigger;
    const dialogs = [...root.querySelectorAll('.vn-dialog')];
    const closeMenus = () => root.querySelectorAll('.vn-desktop details[open],.vn-locale details[open]').forEach(el => el.open = false);
    function close(dialog) {
      dialog.close();
      if (lastTrigger?.isConnected) lastTrigger.focus();
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (link) {
        closeMenus();
        const parentDialog = link.closest('.vn-dialog');
        if (parentDialog?.open) close(parentDialog);
      }
      const trigger = event.target.closest('[data-vn-open]');
      if (trigger) {
        closeMenus();
        lastTrigger = trigger;
        const dialog = document.getElementById(trigger.dataset.vnOpen);
        if (dialog && !dialog.open) { dialog.showModal(); (dialog.matches('.vn-search') ? dialog.querySelector('input[type=search]') : dialog.querySelector('[data-vn-close]')).focus(); }
      }
      const closer = event.target.closest('[data-vn-close]');
      if (closer) close(closer.closest('dialog'));
      if (event.target.matches('.vn-dialog')) {
        const rect = event.target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(event.target);
      }
    });
    dialogs.forEach(dialog => dialog.addEventListener('cancel', event => { event.preventDefault(); close(dialog); }));
    root.querySelectorAll('.vn-desktop>details').forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (detail.open) root.querySelectorAll('.vn-desktop>details').forEach(other => { if (other !== detail) other.open = false; });
      });
      detail.addEventListener('focusout', () => requestAnimationFrame(() => { if (!detail.contains(document.activeElement)) detail.open = false; }));
    });
    document.addEventListener('click', event => { if (!root.contains(event.target)) closeMenus(); });
    document.addEventListener('keydown', event => {
      if (!root.isConnected) return;
      if (event.key === 'Escape') {
        const open = root.querySelector('.vn-desktop details[open],.vn-locale details[open]');
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      }
      if (event.key === '/' && !event.metaKey && !event.ctrlKey && !event.altKey && !event.target.closest('input,textarea,select,[contenteditable=true]') && !document.querySelector('dialog[open]')) {
        event.preventDefault(); root.querySelector('[data-vn-open^="vn-search"]').click();
      }
    });
    const bar = root.querySelector('[data-vn-announcements]');
    if (bar) {
      const messages = [...bar.querySelectorAll('[data-vn-message]')]; let index = 0;
      const update = step => { index = (index + step + messages.length) % messages.length; messages.forEach((el,i) => el.hidden = i !== index); const page = bar.querySelector('[data-vn-page]'); if(page) page.textContent = `${index + 1} / ${messages.length}`; };
      bar.querySelector('[data-vn-prev]')?.addEventListener('click', () => update(-1));
      bar.querySelector('[data-vn-next]')?.addEventListener('click', () => update(1));
      const key = 'lap-announcement:' + messages.map(m => m.textContent.trim()).join('|');
      try { if (sessionStorage.getItem(key) === 'closed' && !window.Shopify?.designMode) bar.hidden = true; } catch(e) {}
      bar.querySelector('[data-vn-dismiss]')?.addEventListener('click', () => { bar.hidden = true; try { sessionStorage.setItem(key,'closed'); } catch(e) {} });
      root.addEventListener('shopify:block:select', event => { const i = messages.findIndex(m => m === event.target || m.contains(event.target)); if (i >= 0) { bar.hidden=false; update(i-index); } });
    }
  }
  const mount = () => document.querySelectorAll('[data-vn-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
